







import Vue from 'vue'
import ProgressBar from 'progressbar.js'

interface State {
  count: number;
  timer: number;  // setInterval用
  progressbar: any | null; // TODO progressbar.jsのインスタンスを型定義したい
}

export default Vue.extend({
  name: 'Countdown',

  data (): State {
    return {
      count: 3,
      timer: NaN,
      progressbar: null,
    }
  },

  mounted () {
    // 進捗の円を生成
    const progressElement = this.$refs.progressbar as SVGPathElement
    this.progressbar = new ProgressBar.Circle(progressElement, {
      strokeWidth: 2, // 1だと細すぎるので見た目に合わせる
      easing: 'linear',
      duration: 1000,
      color: '#fff',
      trailColor: '#ffa7b5',
      svgStyle: null,
    })

    this.timer = window.setInterval(() => {
      if (this.count > 1) {
        this.count--
        this.animateProgress()
      } else {
        clearInterval(this.timer)
      }
    }, 1000)

    this.animateProgress()
  },

  destroyed () {
    this.progressbar.destroy()
  },

  methods: {
    // プログレスバーをアニメーション
    animateProgress () {
      if (this.progressbar) {
        this.progressbar.set(0)
        this.progressbar.animate(1)
      }
    },
  },
})
